module.exports = __webpack_public_path__ + "images/stickers/taco-confused.511723ee0c932684ca39.png";